module.exports = __webpack_public_path__ + "a.no1.07d35f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/a.no1.jpg
// module id = Xy6k
// module chunks = 0